/* eslint camelcase: 0 */
import en_US from './en_US';
import es_ES from './es_ES';
import ja_JP from './ja_JP';
import ko_KR from './ko_KR';
import ru_RU from './ru_RU';
import zh_CN from './zh_CN';
import zh_TW from './zh_TW';

const languages = {
  en_US: en_US,
  es_ES: es_ES,
  ja_JP: ja_JP,
  ko_KR: ko_KR,
  ru_RU: ru_RU,
  zh_CN: zh_CN,
  zh_TW: zh_TW
};

export default languages;
